import { createContext, useContext } from 'react';

type WidthValue = string | number | undefined;

interface PageSidebarContextValue {
  setEffectiveWidth: (width: WidthValue) => void;
  modeOverride?: 'floating-sidepanel';
  /**
   * Controlled maximize handshake. When the host provides `onToggleMaximize`,
   * the panel stops owning its own maximize state and reflects `isMaximized`
   * instead — letting a host (e.g. the docked AppShell toolbar) share one
   * "enlarged" state across sibling panels so a size set on one carries to all.
   * Omit both to keep the panel's built-in, self-contained maximize.
   */
  isMaximized?: boolean;
  onToggleMaximize?: () => void;
}

export const PageSidebarContext = createContext<PageSidebarContextValue | null>(
  null,
);

export const usePageSidebarContext = () => useContext(PageSidebarContext);
